<script setup>
import UmisisModal from '../../../../../../../resources/js/components/umisis/generic/UmisisModal.vue'
import { useModalControl } from '../../../../../../../resources/js/composables/modal/useUmisisModal.js'
const { componentRef: dialog, openModal, closeModal } = useModalControl()
import { ref } from 'vue'
import InputEmail from '../../../../../../../resources/js/components/umisis/form/inputs/InputEmail.vue'
import InputText from '../../../../../../../resources/js/components/umisis/form/inputs/InputText.vue'
import { useUserRoleStore } from '../../stores/userRoleStore.js'
import { useApiAction } from '@/composables/dispatchers/useApiAction.js'
import { useUserManagerStore } from '../../stores/userManagerStore.js'
import { toast }  from 'vue-sonner'
import { useI18n } from 'vue-i18n'
import InputCheckbox from '../../../../../../../resources/js/components/umisis/form/inputs/InputCheckbox.vue'
const { t} = useI18n()

defineExpose({
  openModal,
  closeModal
})

const props = defineProps({
  user: {
    type: Object,
    required: false,
    default:null,
  },
  disableEmailEditing: {
    type: Boolean,
    default: false,
  }
})

const userEmail = ref('')
const userName = ref('')
const userAdmin = ref(false)


const onShow = () => {
  // Populate fields when modal is shown
  userEmail.value = props.user?.email || ''
  userName.value = props.user?.name || ''
  userAdmin.value = props.user?.admin || false
}

const { execute, loading, getError, validationResult } = useApiAction((payload) => {
  if(props.user) {
    // we need to patch
    return useUserManagerStore().itemPatch(props.user.id, payload)
  } else {
    // we need to create
    return useUserManagerStore().itemCreate(payload)
  }
},
{
  onSuccess: () => {
    if(props.user) {
      // updated
      toast.success(t('userManager.notifications.userUpdated'))
    } else {
      // created
      toast.success(t('userManager.notifications.userUpdated'))
    }
    closeModal()
  }
})

const handleOk = async (bvEvent) => {
  bvEvent? bvEvent.preventDefault() : null
  // 2. Just pass the payload, the wrapper handles the rest
  await execute({
    name: userName.value,
    email: userEmail.value,
    admin: userAdmin.value,
  })
}

</script>

<template>
  <UmisisModal ref="dialog" :ok-disabled="loading" :title="$t('userManager.actions.editUser')" @ok="handleOk" @show="onShow">
    <div class="flex flex-col gap-4">
      <InputEmail v-model="userEmail" :validation="validationResult('email')" :error-message="getError('email')" :readonly="disableEmailEditing" />
      <InputText v-model="userName" :validation="validationResult('name')" :error-message="getError('name')" label="Name" />
      <InputCheckbox v-model="userAdmin" label="Is Admin" :validation="validationResult('admin')" :error-message="getError('admin')" />
    </div>
  </UmisisModal>
</template>

<style scoped>

</style>
